import React, { useCallback, useEffect, useState } from "react";
import Page from "../../Components/Page";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Chip,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import FetchHook from "../../Api/FetchHooks";
import moment from "moment";
import AlertComponent from "../../Components/AlertComponent";
import TableComponent from "../../Components/TableComponent";
import { AllInbox } from "@mui/icons-material";
import DateRangePicker from "../../Components/DateRangePicker";
import { formatCurrencyV2, formatDate } from "../../utils/helpers";
import ErrorDisplay from "../../Components/ErrorDisplay";
import UseServerTable from "../../Hooks/UseServerTable";

const Disbursements = () => {
  const location = useLocation();
  const loggedInUser = useSelector((state) => state?.auth?.user);

  const [startDate, setStartDate] = useState(new Date("2025-01-01"));
  const [endDate, setEndDate] = useState(new Date());
  const [status, setStatus] = useState("");

  const [dialog, setDialog] = useState({
    open: false,
    type: null,
    label: null,
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const [data, setData] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });

  // const [loading, response, request] = FetchHook();

  const openDialog = (type, label) => setDialog({ open: true, type, label });
  const closeDialog = () => setDialog({ open: false, type: null, label: null });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const start = moment(startDate).format("YYYY-MM-DD");
  const end = moment(endDate).format("YYYY-MM-DD");

  const { gridProps, error, refresh } = UseServerTable({
    baseUrl: `/disbursement?status=${status}&start_date='${start}'&end_date='${end}'`,
    onSuccess: (data) => {
      setData(data.Report);
    },
  });

  useEffect(() => {
    if (error) {
      setSnackbar({
        open: true,
        message: error.message,
        severity: error.severity,
      });
    }
  }, [error]);

  // const fetchData = useCallback(async () => {
  //   try {
  // const start = moment(startDate).format("YYYY-MM-DD");
  // const end = moment(endDate).format("YYYY-MM-DD");
  //     await request({
  //       url: `/disbursement?status=${status}&start_date='${start}'&end_date='${end}'&page_number=${
  //         paginationModel.page + 1
  //       }&page_size=${paginationModel.pageSize}`,
  //     });
  //   } catch (error) {
  //     const errorMessage =
  //       error.response?.data?.StatusMessage ??
  //       error.response?.data?.message ??
  //       error.message ??
  //       "An unexpected error occurred. Please try again.";

  //     setSnackbar({
  //       open: true,
  //       severity: "error",
  //       message: errorMessage,
  //     });
  //   }
  // }, [status, startDate, endDate, paginationModel]);

  // useEffect(() => {
  //   fetchData();
  // }, [fetchData]);

  // useEffect(() => {
  //   if (response && response.status === 200 && response.data.StatusCode === 0) {
  //     setData(response.data.Report || []);
  //     setRowCount(response.data.Total || 0);
  //   }
  // }, [response]);

  const cols = [
    {
      field: "id",
      headerName: "Id",
      width: 150,
    },
    {
      field: "reference",
      headerName: "Reference",
      width: 150,
    },
    {
      field: "transaction_id",
      headerName: "Transaction Id",
      width: 150,
    },
    {
      field: "msisdn",
      headerName: "Msisdn",
      width: 150,
    },
    {
      field: "b2c_charge",
      headerName: "B2C charge",
      width: 150,
    },
    {
      field: "status",
      headerName: "Status",
      width: 150,
    },
    {
      field: "description",
      headerName: "Description",
      width: 300,
    },
    {
      field: "created_on",
      headerName: "Created On",
      width: 200,
      valueFormatter: (params) => formatDate(params?.value),
    },
    {
      field: "last_updated_on",
      headerName: "Last Updated On",
      width: 200,
      valueFormatter: (params) => formatDate(params?.value),
    },
  ];

  const columns = [
    {
      field: "last_updated_on",
      headerName: "Transaction time",
      minWidth: 170,
      flex: 1,
      valueFormatter: (params) => formatDate(params?.value),
    },
    {
      field: "reference",
      headerName: "Reference",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "transaction_id",
      headerName: "Transaction ID",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "msisdn",
      headerName: "Destination",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "amount",
      headerName: "Amount",
      minWidth: 170,
      flex: 1,
      valueFormatter: (params) => formatCurrencyV2(params?.value),
      valueGetter: (params) =>
        parseInt(params?.row?.amount) + parseInt(params?.row?.b2c_charge),
    },
    {
      field: "disburse",
      headerName: "Disbursed Amount",
      minWidth: 170,
      flex: 1,
      valueFormatter: (params) => formatCurrencyV2(params?.value),
    },
    {
      field: "description",
      headerName: "Description",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 170,
      flex: 1,
      renderCell: (params) => {
        return (
          <Chip
            label={
              params?.value === 1
                ? "pending"
                : params?.value === 2
                  ? "processed"
                  : "pending"
            }
            color={
              params?.value === 1
                ? "secondary"
                : params?.value === 2
                  ? "info"
                  : "secondary"
            }
          />
        );
      },
    },
  ];

  return (
    <Page title={"Disbursments"}>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <Card>
        {/* <CardHeader
          action={
            <Box sx={{ my: 2, display: "flex", gap: 2 }}>
              <FormControl sx={{ width: "150px" }}>
                <InputLabel id="status" size="small">Status</InputLabel>

                <Select
                  labelId="loan_status"
                  id="loan_status"
                  value={status}
                  label="status"
                  onChange={(e) => {
                    setStatus(e.target.value);
                  }}
                  size="small"
                >
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="inactive">Inactive</MenuItem>
                  <MenuItem value="domant">Dormant</MenuItem>
                  <MenuItem value="suspended">Suspended</MenuItem>
                  <MenuItem value="closed">Closed</MenuItem>
                  <MenuItem value="pending">Pending</MenuItem>
                  <MenuItem value="cancelled">Cancelled</MenuItem>
                  <MenuItem value="incomplete">Incomplete</MenuItem>
                  <MenuItem value="complete">Complete</MenuItem>
                </Select>
              </FormControl>

              <DateRangePicker
                startDate={startDate}
                endDate={endDate}
                onStartDateChange={setStartDate}
                onEndDateChange={setEndDate}
                onSearch={refresh}
                loading={gridProps.loading}
              />
            </Box>
          }
        /> */}
        <CardContent>
          {gridProps.loading ? (
            <Grid display={"flex"} justifyContent={"center"}>
              <CircularProgress />
            </Grid>
          ) : data && data.length > 0 ? (
            <TableComponent rows={data} columns={columns} {...gridProps} />
          ) : (
            <ErrorDisplay
              message="You have no transactions!"
              icon={
                <AllInbox color="secondary" sx={{ mx: "auto", fontSize: 80 }} />
              }
            />
          )}
        </CardContent>
      </Card>
    </Page>
  );
};

export default Disbursements;
